module.exports = __webpack_public_path__ + "img/profit.8061e6c1.png";